import { Order, Status, statusesMap } from 'entities/orders';
import { FC, useEffect, useState } from 'react';
import { TColorVariant, Typography } from 'shared/ui/typography';

export const OrderStatus: FC<{ order: Order; enabledStatuses?: Status[] }> = ({
	order,
	enabledStatuses,
}) => {
	const [colorText, setColorText] = useState<TColorVariant>('neutral');

	useEffect(() => {
		if (order) {
			switch (order.status) {
				case 'visit_ended':
					setColorText('success');
					break;
				case 'visit_started':
					setColorText('success');
					break;
				case 'cancelled':
				case 'visit_missed':
					setColorText('danger');
					break;
				default:
					setColorText('neutral');
					break;
			}
		}
	}, [order]);

	if (enabledStatuses) {
		if (enabledStatuses.includes(order.status)) {
			return (
				<Typography
					colorVariant={colorText}
					pointer={true}
					whiteSpace="nowrap"
					style={{ textAlign: 'right', marginTop: 'auto' }}
				>
					{statusesMap.get(order.status)}
				</Typography>
			);
		}

		return null;
	}

	return (
		<Typography colorVariant={colorText} pointer={true}>
			{statusesMap.get(order.status)}
		</Typography>
	);
};
